export default __webpack_public_path__ + "static/media/pic96.0477af88.jpg";